module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/header-image-mobile-01-9b86170bd1b5fc8f6a23fd848f54669e.jpg";